import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const links = [
    { to: '/', label: 'Home' },
    { to: '/about-us', label: 'About Us' },
    { to: '/services', label: 'Services' },
    { to: '/contact-us', label: 'Contact Us' },
];

const linkClass = ({ isActive }) =>
    'relative block py-2 font-bold transition-colors hover:text-gold ' +
    "after:absolute after:bottom-1 after:left-0 after:h-0.5 after:bg-gold after:transition-all after:duration-300 after:content-[''] hover:after:w-full " +
    (isActive ? 'text-gold after:w-full' : 'text-neutral-500 after:w-0');

const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <nav className="w-full shadow-md">
            <div className="flex flex-wrap items-center justify-between px-4 py-3 sm:px-8">
                <div className="flex items-center gap-4">
                    <Link to="/">
                        <img src="HMR_clear.png" alt="HMR Decor logo" className="h-14 w-14 sm:h-[70px] sm:w-[70px]" />
                    </Link>
                    <a href="https://www.instagram.com/hmr.decor/" target="_blank" rel="noreferrer">
                        <img src="instagram.png" alt="Instagram" className="h-6 w-6 mix-blend-multiply" />
                    </a>
                    <a href="https://www.tiktok.com/@hmr.decor" target="_blank" rel="noreferrer">
                        <img src="tik-tok.png" alt="TikTok" className="h-6 w-6 mix-blend-multiply" />
                    </a>
                </div>
                <button
                    type="button"
                    className="rounded-md border border-neutral-300 p-2 text-neutral-600 lg:hidden"
                    aria-controls="responsive-navbar-nav"
                    aria-expanded={open}
                    aria-label="Toggle navigation"
                    onClick={() => setOpen(!open)}
                >
                    <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
                <ul
                    id="responsive-navbar-nav"
                    className={`${open ? 'flex' : 'hidden'} w-full flex-col items-center gap-1 pt-3 lg:flex lg:w-auto lg:flex-row lg:gap-8 lg:pt-0`}
                >
                    {links.map(({ to, label }) => (
                        <li key={to}>
                            <NavLink to={to} end className={linkClass} onClick={() => setOpen(false)}>
                                {label}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
